export default __webpack_public_path__ + "static/media/Resume.7a8ffdb7.pdf";